module.exports = __webpack_public_path__ + "static/4-e59bcdf23663712b1facd5dbacfaad5e.jpg";